import { Button } from "@/components/ui/button";
import { MessageCircle, X } from "lucide-react";
import { createPortal } from "react-dom";
import { useState } from "react";
import { Persona } from "@/api/personas.ts";
import { useAuth } from "@/hooks/use-auth";

export default function PersonaChatFixed({
  chatUrl,
  personaData,
}: {
  chatUrl: string;
  personaData: Pick<Persona, "persona_id" | "name">;
}) {
  const [showChat, setShowChat] = useState(false);
  const { authenticated, username } = useAuth();

  const fullChatUrl = authenticated
    ? `${chatUrl}&user=${encodeURIComponent(username)}`
    : chatUrl;

  if (!chatUrl) return null;

  return (
    <>
      <div>
        <Button
          onClick={() => setShowChat(true)}
          className="flex  w-full items-center gap-2  text-accent justify-center"
          variant="outline"
          data-testid={`chat-button-${personaData.persona_id}`}
        >
          <MessageCircle className="w-5 h-5" />
          Chat with agent
        </Button>
      </div>

      {showChat &&
        createPortal(
          <div
            onClick={(e) => e.stopPropagation()}
            className="fixed bottom-4 right-4 z-[1000]"
          >
            <div className="fixed bottom-4 right-4 z-[1000]">
              <div className="bg-background border rounded-lg shadow-xl w-[480px] max-w-[90vw] h-[700px] max-h-screen flex flex-col">
                <div className="flex justify-between items-center p-4 border-b bg-background">
                  <h2 className="font-semibold text-lg">
                    Chat with {personaData.name}
                  </h2>
                  <Button
                    variant="ghost"
                    size="icon"
                    onClick={() => setShowChat(false)}
                    className="hover:bg-background"
                    data-testid="close-chat-button"
                  >
                    <X className="h-4 w-4" />
                  </Button>
                </div>
                <div className="relative flex-1">
                  <iframe
                    src={fullChatUrl}
                    title="Chat Interface"
                    className="absolute w-full h-full"
                    allow="fullscreen *"
                    allowFullScreen
                    sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-popups-to-escape-sandbox"
                  />
                </div>
              </div>
            </div>
          </div>,
          document.body,
        )}
    </>
  );
}
